// Shared brand → CSS-variable helpers. These MUST match the formats TenantContext writes
// (--primary-color, --secondary-color, --brand-primary "R G B" channels, light/dark shades,
// --brand-accent), so the brand editor's live preview tracks the real theme exactly.

export const hexToRgbChannels = (hex) => {
  let c = (hex || '').replace('#', '')
  if (c.length === 3) c = c.split('').map((x) => x + x).join('')
  const num = parseInt(c || '000000', 16)
  return `${num >> 16} ${(num >> 8) & 255} ${num & 255}`
}

export const adjustHexToChannels = (hex, factor) => {
  let c = (hex || '').replace('#', '')
  if (c.length === 3) c = c.split('').map((x) => x + x).join('')
  const num = parseInt(c || '000000', 16)
  const r = Math.min(255, Math.max(0, Math.round((num >> 16) * factor)))
  const g = Math.min(255, Math.max(0, Math.round(((num >> 8) & 255) * factor)))
  const b = Math.min(255, Math.max(0, Math.round((num & 255) * factor)))
  return `${r} ${g} ${b}`
}

/**
 * Apply the six brand CSS variables to a CSSStyleDeclaration target.
 * @param {CSSStyleDeclaration} style - e.g. document.documentElement.style (whole app),
 *   or someEl.style (a scoped preview container — used by the super-admin editor so it
 *   does NOT repaint the admin's own chrome).
 */
export function applyBrandVars(style, primaryColor, secondaryColor) {
  if (!style) return
  style.setProperty('--primary-color', primaryColor)
  style.setProperty('--secondary-color', secondaryColor)
  try {
    style.setProperty('--brand-primary', hexToRgbChannels(primaryColor))
    style.setProperty('--brand-primary-light', adjustHexToChannels(primaryColor, 1.3))
    style.setProperty('--brand-primary-dark', adjustHexToChannels(primaryColor, 0.7))
    style.setProperty('--brand-accent', hexToRgbChannels(secondaryColor))
  } catch (e) {
    /* non-fatal: bad hex during typing */
  }
}
